import { SITES } from '../gen/lang.js';

const findSiteByDomain = (domain) => {
    return SITES.find((site) => site.domain === domain);
};
const getLanguageFromLocale = (locale) => {
    return locale.substring(0, locale.indexOf('-'));
};

export { findSiteByDomain, getLanguageFromLocale };
//# sourceMappingURL=langService.js.map
